import React, { useRef, useEffect } from 'react';
import { Search, X } from 'lucide-react';

const SearchBar = ({ 
    searchTerm, 
    onSearchChange, 
    onClearSearch, 
    searchLoading, 
    disabled = false 
}) => {
    const inputRef = useRef(null);

    // Keep focus on the input when searchLoading changes
    useEffect(() => {
        if (!disabled) {
            // Small delay to ensure DOM updates are complete
            setTimeout(() => {
                // Add proper null checks
                if (inputRef.current && document.activeElement !== inputRef.current) {
                    try {
                        inputRef.current.focus();
                    } catch (error) {
                        console.warn('Focus error in SearchBar:', error);
                    }
                }
            }, 10);
        }
    }, [searchLoading, disabled]);

    // This wrapper function extracts the value from the event
    const handleInputChange = (e) => {
        onSearchChange(e.target.value);
    };

    // Handle clear and maintain focus
    const handleClear = () => {
        onClearSearch();
        // Refocus after clearing with null check
        setTimeout(() => {
            if (inputRef.current) {
                try {
                    inputRef.current.focus();
                } catch (error) {
                    console.warn('Focus error after clear:', error);
                }
            }
        }, 10);
    };

    return (
        <div className="relative">
            <Search className={`w-4 h-4 absolute left-3 top-1/2 transform -translate-y-1/2 ${
                searchLoading ? 'animate-pulse text-[#275F97]' : 'text-gray-400'
            }`} />
            <input
                ref={inputRef}
                type="text"
                placeholder="Search candidates..."
                value={searchTerm}
                onChange={handleInputChange}
                className="pl-10 pr-10 py-2 border border-gray-300 rounded-lg outline-none focus:border-[#275F97] focus:ring-1 focus:ring-[#275F97] w-64 text-sm"
                disabled={disabled || searchLoading}
                autoComplete="off"
            />
            {searchTerm && (
                <button
                    onClick={handleClear}
                    disabled={searchLoading}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 disabled:opacity-50"
                    title="Clear search"
                >
                    <X className="w-4 h-4" />
                </button>
            )}
        </div>
    );
};

export default SearchBar;